import { Switch } from '@material-ui/core';
import React, { FC } from 'react';
import './index.scss';

type SwitchIosParentProps = {
	isChecked: boolean;
	clickHandler: () => void;
};

const SwitchIos: FC<SwitchIosParentProps> = ({ clickHandler, isChecked }: SwitchIosParentProps) => {
	return <Switch className="name" checked={isChecked} onChange={clickHandler} />;
};

export default SwitchIos;
